import React, {useContext} from "react";
import {CalendarEntry, CalendarTypeEnum} from "../../../../../../api/grs";
import FormHeader from "../../../../../Form/FormHeader";
import CalendarEntryDescription from "./CalendarEntryDescription";
import CalendarEntryVenue from "./CalendarEntryVenue";
import CalendarEntryBillingDropdown from "./CalendarEntryBillingDropdown";
import {ShowAdvancedControlsContext} from "../../../../../../contexts/advancedControls";
import FormRow from "../../../../../Form/FormRow";
import {DebounceInput} from "react-debounce-input";
import {setCalendarEntry} from "../../../../../../store/calendarEntry/actions/CalendarEntryActions";
import {useDispatch} from "react-redux";
import CalendarEntryArea from "./CalendarEntryArea";

export default function CalendarEntryGeneralDetails(props: CalendarEntry) {
    const showAdvancedContext = useContext(ShowAdvancedControlsContext);

    return (
        <React.Fragment>
            <FormHeader headerName={"General Details"} />

            {props.calendarType === CalendarTypeEnum.Frontline && <FrontlineFields {...props} />}

            {props.calendarType !== CalendarTypeEnum.Frontline && <DefaultFields {...props} />}

            {showAdvancedContext?.show && <CalendarEntryBillingDropdown {...props} />}
        </React.Fragment>
    );
}

function FrontlineFields(props: CalendarEntry) {
    const dispatch = useDispatch();

    return (
        <>
            <FormRow rowName={"Call Sign"} columnDetailClassName={"pl-0 pr-0"}>
                <DebounceInput
                    debounceTimeout={300}
                    value={props.callsign}
                    onChange={(event) => {
                        const {value} = event.target;

                        dispatch(
                            setCalendarEntry({
                                ...props,
                                callsign: value
                            })
                        );
                    }}
                    className="input-fields"
                    placeholder="Enter optional Call Sign"
                />
            </FormRow>

            <FormRow rowName={"Vehicle Registration"} columnDetailClassName={"pl-0 pr-0"}>
                <DebounceInput
                    debounceTimeout={300}
                    value={props.vehicleIdentifier}
                    onChange={(event) => {
                        const {value} = event.target;

                        dispatch(
                            setCalendarEntry({
                                ...props,
                                vehicleIdentifier: value
                            })
                        );
                    }}
                    className="input-fields"
                    placeholder="Enter optional vehicle registration"
                />
            </FormRow>

            <CalendarEntryArea {...props} />
            <CalendarEntryVenue {...props} fieldName="Ambulance Station" />
        </>
    );
}

function DefaultFields(props: CalendarEntry) {
    const dispatch = useDispatch();

    return (
        <>
            <CalendarEntryDescription {...props} />
            <CalendarEntryVenue {...props} />

            <FormRow rowName={"Number of vehicles required"} columnDetailClassName={"pl-0 pr-0"}>
                <DebounceInput
                    debounceTimeout={300}
                    value={props.numVehicles}
                    type="number"
                    step={1}
                    onChange={(event) => {
                        const {value} = event.target;
                        let numVehicles: number | undefined = undefined;
                        if (value && value.trim() !== "") {
                            numVehicles = parseInt(value);
                            if (isNaN(numVehicles) || numVehicles < 0) {
                                numVehicles = undefined;
                            }
                        }

                        dispatch(
                            setCalendarEntry({
                                ...props,
                                numVehicles: numVehicles
                            })
                        );
                    }}
                    className="input-fields"
                    placeholder="Enter the number of vehicles"
                />
            </FormRow>
        </>
    );
}
